import Vue from "vue";
import VueRouter from "vue-router";
import l from "../locales";
const L = l.router;

Vue.use(VueRouter);

const routers = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    component: () => import("../views/layout/TabbarLayout"),
    meta: { hidden: true, title: L.router_home },
    children: [
      {
        path: "/home",
        name: "index",
        component: () => import("../views/index"),
        meta: { hidden: true, title: L.router_home, goback: true },
      },
      {
        path: "/order",
        name: "order",
        component: () => import("../views/order"),
        meta: {
          hidden: true,
          title: L.router_order,
          requireAuth: true,
          goback: true,
        },
      },
      {
        path: "/my",
        name: "my",
        component: () => import("../views/my"),
        meta: { hidden: true, title: L.router_my, goback: true },
      },
    ],
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("../views/order/detail"),
    meta: { hidden: true, title: L.router_details, requireAuth: true },
  },
  {
    path: "/confirmLoan",
    name: "confirmLoan",
    component: () => import("../views/index/confirmLoan"),
    meta: { hidden: true, title: L.router_confirm_loan, requireAuth: true },
  },
  {
    path: "/confirmWithdrawal",
    name: "confirmWithdrawal",
    component: () => import("../views/index/confirmWithdrawal"),
    meta: {
      hidden: true,
      title: L.router_confirm_withdrawal,
      requireAuth: true,
    },
  },
  {
    path: "/idCard",
    name: "idCard",
    component: () => import("../views/authenticationProcess/idCard"),
    meta: { hidden: true, title: L.router_idCard, requireAuth: true },
  },
  {
    path: "/basicInformation",
    name: "basicInformation",
    component: () => import("../views/authenticationProcess/basicInformation"),
    meta: { hidden: true, title: L.router_basicInformation, requireAuth: true },
  },
  {
    path: "/work",
    name: "work",
    component: () => import("../views/authenticationProcess/work"),
    meta: { hidden: true, title: L.router_work, requireAuth: true },
  },
  {
    path: "/other",
    name: "other",
    component: () => import("../views/authenticationProcess/other"),
    meta: { hidden: true, title: L.router_other, requireAuth: true },
  },
  {
    path: "/bankcard",
    name: "bankcard",
    component: () => import("../views/bankcard/index"),
    meta: {hidden: true, title: L.account_info, requireAuth: true},
  },
  {
    path: "/addcard",
    name: "addcard",
    component: () => import("../views/bankcard/addcard"),
    meta: {hidden: true, title: L.account_info, requireAuth: true},
  },
  {
    path: "/pay",
    name: "pay",
    component: () => import("../views/pay/index"),
    meta: { hidden: true, title: L.router_pay_immediately, requireAuth: true },
  },
  {
    path: "/rollover",
    name: "rollover",
    component: () => import("../views/pay/rollover.vue"),
    meta: { hidden: true, title: L.router_pay_rollover, requireAuth: true },
  },
  {
    path: "/immediately",
    name: "immediately",
    component: () => import("../views/pay/immediately.vue"),
    meta: { hidden: true, title: L.router_pay_immediately, requireAuth: true },
  },
  {
    path: "/oxPay",
    name: "oxPay",
    component: () => import("../views/pay/payChannel/oxPay.vue"),
    meta: { hidden: true, title: "oxPay", requireAuth: true },
  },
  {
    path: "/uuPay",
    name: "uuPay",
    component: () => import("../views/pay/payChannel/uuPay.vue"),
    meta: { hidden: true, title: "uuPay", requireAuth: true },
  },
  {
    path: "/vnCamelPay",
    name: "vnCamelPay",
    component: () => import("../views/pay/payChannel/vnCamelPay.vue"),
    meta: { hidden: true, title: "vnCamelPay", requireAuth: true },
  },
  {
    path: "/wePay",
    name: "wePay",
    component: () => import("../views/pay/payChannel/wePay.vue"),
    meta: { hidden: true, title: "wePay", requireAuth: true },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login"),
    meta: { hidden: true, title: L.router_login },
  },
  {
    path: "/loginReset",
    name: "loginReset",
    component: () => import("../views/login/reset"),
    meta: { hidden: true, title: L.router_login_reset },
  },
  {
    path: "/setPass",
    name: "setPass",
    component: () => import("../views/login/setPass"),
    meta: { hidden: true, title: L.router_login_setPwd, requireAuth: true },
  },
  {
    path: "/personalData",
    name: "personalData",
    component: () => import("../views/my/personalData"),
    meta: { hidden: true, title: L.router_personal_data, requireAuth: true },
  },
  {
    path: "/help",
    name: "help",
    component: () => import("../views/my/help"),
    meta: {
      hidden: true,
      title: L.router_help,
      requireAuth: true,
      goback: true,
    },
  },
  {
    path: "/contactUs",
    name: "contactUs",
    component: () => import("../views/my/contactUs"),
    meta: { hidden: true, title: L.text_contact_us, requireAuth: true },
  },
  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: () => import("../views/index/privacyPolicy.vue"),
    meta: { hidden: true, title: L.router_privacy_policy, requireAuth: true },
  },
  {
    path: "/download",
    name: "download",
    component: () => import("../views/download"),
    meta: { hidden: true, title: "榮耀貸" },
  },
  {
    path: "*",
    name: "Error",
    component: () => import("../views/404"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: "./",
  routes: routers,
  scrollBehavior() {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // console.log("to  from /// ", to, from);
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 默认跳转 url参数
  let defaultQuery = {};
  // 当前渠道数据
  // let channel = localStorage.getItem("channel");
  defaultQuery.path = to.path;
  // if (channel) {
  defaultQuery.query = { ...to.query };
  // defaultQuery.query = { ...to.query, channel };
  // }
  // 当前登录信息
  const userInfo = JSON.parse(localStorage.getItem("userInfo")||"{}");

  // 当前环境
  const isDev = process.env.NODE_ENV == "development";
  // 忽略拦截路由 为 1 时忽略   0 / 没有值 时 不忽略
  const showDev = localStorage.getItem("showDev");
  const ignoreWeb = "1";
  let platform = navigator.platform;
  // 判断query参数有没有channel
  console.log(isDev, ignoreWeb);
  if (
  (["Win32", "MacIntel"].includes(platform) &&
      !(isDev && ignoreWeb == "1")) && !showDev
  ) {
    //   if (ignoreWeb != "1") {
    // 判断当前浏览器是否是web端
    if (to.path == "/download") {
      console.log("2222222222");
      next();
    } else {
      console.log("111111111");
      next({
        ...defaultQuery,
        path: "/download",
      });
    }
  } else if (to.query?.channel) {
    console.log("333333333");
    next();
    return;
  } else if (to.meta.requireAuth) {
    // 目标页面是否需要权限
    // 需要权限 是否存在token
    if (userInfo) {
      // 存在token直接前往
      console.log("4444444444");
      // next({ ...defaultQuery });
      next();
    } else {
      // 不存在token前往login页
      console.log("55555555555");
      if(process.env.VUE_APP_GENRE === "nested"){
        console.log("嵌套不跳转")
        next();
      }else{
        next({
            ...defaultQuery,
            path: "/login",
        });
      }
    }
  } else {
    // 不需要权限 判断目标页是否为login
    if (to.path == "login") {
      // 为login页 判断token是否存在
      if (userInfo) {
        // 存在直接返回

        console.log("666666666666");
        next({
          ...defaultQuery,
          path: from.fullPath,
        });
      } else {
        // 不存在就去login页
        console.log("777777777777");
        // next({ ...defaultQuery });
        next();
      }
    } else {
      // 不是登录页 直接前往
      console.log("8888888888888");
      next();
    }
  }
});

export default router;
